import YaSub from './src/YaSub';
YaSub.install=function(Vue,ops){
  Vue.component(YaSub.name,YaSub);
}
export default YaSub;



// WEBPACK FOOTER //
// ./src/packages/YaSub/index.js